import axios from "axios";

const cleanBaseUrl = (value) => {
  if (!value) return "";
  return String(value).trim().replace(/\/+$/, "");
};

const API_BASE_URL =
  cleanBaseUrl(process.env.REACT_APP_API_URL) ||
  `${window.location.origin}/api`;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const normalizeError = (error, fallback) => ({
  success: false,
  error:
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    fallback,
  openingOverrides: [],
});

export const getOpeningOverridesApi = async () => {
  try {
    const response = await apiClient.get("/opening-overrides");
    return {
      success: Boolean(response?.data?.success),
      openingOverrides: response?.data?.openingOverrides || [],
    };
  } catch (error) {
    return {
      success: true,
      openingOverrides: [],
      source: "fallback_due_to_error",
      error:
        error?.response?.data?.error ||
        error?.message ||
        "Die Offnungszeiten konnten nicht geladen werden.",
    };
  }
};

export const upsertOpeningOverrideApi = async (date, { closedAllDay = false, periods = [] } = {}) => {
  try {
    const response = await apiClient.put("/opening-overrides", {
      date,
      closedAllDay,
      periods,
    });
    return {
      success: Boolean(response?.data?.success),
      override: response?.data?.override || null,
      openingOverrides: response?.data?.openingOverrides || [],
    };
  } catch (error) {
    return normalizeError(error, "Die Offnungszeiten konnten nicht gespeichert werden.");
  }
};

export const deleteOpeningOverrideApi = async (date) => {
  try {
    const response = await apiClient.delete(`/opening-overrides/${date}`);
    return {
      success: Boolean(response?.data?.success),
      openingOverrides: response?.data?.openingOverrides || [],
    };
  } catch (error) {
    return normalizeError(error, "Die Anpassung konnte nicht entfernt werden.");
  }
};
